import { ServiceRecommendationPartTotalPrice } from "./service-recommendation-part--total-price"
import { ServiceRecommendationPartUnitPrice } from "./service-recommendation-part-unit-price"
import styles from '../../serviceRecommendation.module.scss';

type PriceWrapperProps = {
    totalprice: string,
    price: string,
    currency: string,
    translation: string

}

export const ServiceRecommendationPriceWrapper = ({ totalprice, price, currency, translation }: PriceWrapperProps) => {
    return (
        <div className={styles['price-wrapper']}>
            <ServiceRecommendationPartTotalPrice price={totalprice} currency={currency} />
            <ServiceRecommendationPartUnitPrice price={price} translation={translation} />
        </div>
    )
}